import { useIsMobileScreenSize } from '@buffer-mono/popcorn'

/**
 * Returns true when the calendar should render in mobile mode.
 */
export function useCalendarMobileMode(): boolean {
  return useIsMobileScreenSize()
}
